import { useState, useEffect } from "react";

//全站 mobile / web 切換的單一真相來源
//規則（依「直 = 大號 mobile、橫 = 小號 web」設計）：
//  1. 短邊 < 600 → 永遠 mobile（手機橫握也算手機）
//  2. 短邊 >= 600 + portrait → mobile（平板直 = 大號 mobile）
//  3. 短邊 >= 600 + landscape → web（平板橫 = 小號 web / 桌機）
//這樣 iPad Pro 12.9 直握（1024 寬）也會正確走 mobile JSX，
//iPhone Pro Max 橫握（932 寬）也會正確走 mobile JSX
function calcIsMobile() {
  if (typeof window === "undefined") return false;
  const w = window.innerWidth;
  const h = window.innerHeight;
  const shortSide = Math.min(w, h);
  if (shortSide < 600) return true;
  return h > w;
}

export default function useIsMobile() {
  const [isMobile, setIsMobile] = useState(calcIsMobile);

  useEffect(() => {
    const onChange = () => setIsMobile(calcIsMobile());
    window.addEventListener("resize", onChange);
    window.addEventListener("orientationchange", onChange);
    return () => {
      window.removeEventListener("resize", onChange);
      window.removeEventListener("orientationchange", onChange);
    };
  }, []);

  return isMobile;
}
